import { Injectable } from '@angular/core';
import { Child } from '../models/child';

/**
 * 모든 페이지가 공유할 정보 모음
 * App.ts 에서 provide 되어 오직 하나의 객체만 존재해야 함 (singleton)
 */
@Injectable()
export class Globals {

  /**
   * 아동 정보 목록
   * 다른 페이지에서 아동 정보를 사용할 수 있도록
   * 로그인 페이지는 saveChildren()을 통해 반드시 저장해야 함
   */
  private $children: Child[];

  /**
   * 현재 출력하고 있는 아동 정보 인덱스
   */
  private $curr: Child;

  /**
   * 현재 아동 정보 목록에 해당하는 센터 목록
   */
  private $centerNums: number[];

  constructor() {}

  /**
   * 아동 목록 저장, 받은 정보를 깊은 복사 및 타입을 명시하여 저장함
   * 배열이 아닌 인자가 들어오면 TypeError 발생
   */
  saveChildren(children: any[]) {
    if (!Array.isArray(children)) {
      throw new TypeError('children : 배열이 아닙니다.');
    }

    this.$children = [];
    this.$centerNums = [];

    for (let i = 0, d; d = children[i]; i += 1) {
      this.$children[i] = new Child(d);
      if (this.$centerNums.indexOf(this.$children[i].centerNum) === -1) {
        this.$centerNums.push(this.$children[i].centerNum);
      }
    }
    this.$curr = this.$children[0];
  }

  /**
   * 아동 번호로 현재 아동 변경, 없는 식별 번호라면 변경하지 않음
   */
  setChildByNum(bmiNum: number) {
    this.$children.forEach((child) => {
      if (child.num === bmiNum) {
        this.child = child;
        return;
      }
    });
  }

  /**
   * 아동 정보 목록
   */
  get children(): Child[] { return this.$children; }

  /**
   * 현재 아동 저장
   */
  set child(child: Child) {
    this.$curr = child;
  }

  /**
   * 현재 아동 정보
   */
  get child(): Child { return this.$curr; }

  /**
   * @return {number[]} 현재 아동 정보 목록에 해당하는 센터 목록
   */
  get centerNums(): number[] { return this.$centerNums; }
}
